import socialApiClient from "./services/social-api-client";

/**
 * Obtiene el blob de una imagen generada (URL remota vía API o blob/data URL local).
 */
export async function fetchAiGeneratedImageBlob(
  imageUrl: string,
  companyId: string | null | undefined
): Promise<Blob> {
  if (imageUrl.startsWith("blob:") || imageUrl.startsWith("data:")) {
    const res = await fetch(imageUrl);
    return res.blob();
  }
  const { data } = await socialApiClient().get("nanobanana/download-image", {
    responseType: "blob",
    params: { imageUrl, companyId },
  });
  return data as Blob;
}
